import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {CbProps, DestinationRet} from '../destination/types'

export const getInitDestination = (
  editHub?: Hub
): DestinationRet | undefined => {
  if (!editHub) {
    return undefined
  }

  const tmpl = editHub?.data?.movementTemplate
  if (!tmpl) {
    return undefined
  }

  const project = getObj(tmpl.destinationProjectId)
  const board = getObj(tmpl.destinationBoardId)
  const column = getObj(tmpl.destinationColumnId)

  return {project, board, column}
}

const getObj = (id: DataObjectId): CbProps | undefined => {
  if (!id) {
    return undefined
  }

  const box = Sync.getCurrentSandbox()
  const obj = box.getHub(id)
  if (!obj) {
    return undefined
  }

  return {id, title: obj.title}
}
